//@flow
import React, { useEffect, useRef, useState } from 'react';
// Styles
import './NewsLetter.css';
// Assets
import inboxIcon from '../images/forward_to_inbox.svg';
import thumbUp from '../images/thumb_up_alt.svg';
import check from '../images/check.svg';
import closeX from '../images/closeX.svg';
// Helpers
import { validateEmail } from '../../common';
// Components
import Reaptcha from 'reaptcha';
import { RecaptchaDisclaimer } from '../../common';

type Props = {
  postNewsLetterEmail: (email: string) => void,
  loadingNewsLetterEmail: boolean,
};

const NewsLetter = ({ postNewsLetterEmail, loadingNewsLetterEmail }: Props) => {
  const [userEmail, setUserEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [isEmailInvalid, setIsEmailInvalid] = useState(false);
  const captchaRef = useRef(null);

  useEffect(() => {
    if (validateEmail(userEmail) && isEmailInvalid) {
      setIsEmailInvalid(false);
    }
  }, [userEmail, isEmailInvalid]);

  const onVerify = () => {
    postNewsLetterEmail(userEmail);
    setSubscribed(true);
    setIsEmailInvalid(false);
    captchaRef.current.reset();
  };

  const onSubmit = e => {
    e.preventDefault();
    if (validateEmail(userEmail)) {
      captchaRef.current.execute();
    } else {
      setIsEmailInvalid(true);
    }
  };

  return (
    <form
      className="newsletter-wrapper"
      data-type="subscription"
      onSubmit={onSubmit}
    >
      <div className="newsletter-row">
        <img className="newsletter-icon" src={inboxIcon} alt="Inbox" />
        <div className="newsletter-content">
          <h3 className="newsletter-content-title">Fique por dentro</h3>
          <p className="newsletter-content-text">
            de todas as novidades e promoções
          </p>
        </div>
      </div>

      <div className="news-letter-input-wrapper">
        <input
          className="newsletter-input"
          type="email"
          placeholder="Digite o seu email"
          onChange={e => setUserEmail(e.target.value)}
          value={userEmail}
          id="EMAIL"
          name="EMAIL"
        />
        <Reaptcha
          ref={captchaRef}
          onVerify={onVerify}
          size="invisible"
          sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
          badge="bottomleft"
          hl="pt-BR"
        />
        <button
          type="submit"
          disabled={loadingNewsLetterEmail}
          className={`newsletter-button`}
        >
          {!isEmailInvalid ? (
            <img
              className="newsletter-icon-thumbs"
              src={!subscribed ? thumbUp : check}
              alt={!subscribed ? 'Legal' : 'Check'}
            />
          ) : (
            <img
              className="newsletter-icon-thumbs"
              src={closeX}
              alt={'Email inválido'}
            />
          )}
        </button>
      </div>

      <RecaptchaDisclaimer className="newsletter-recaptcha-disclaimer" />
    </form>
  );
};

export default NewsLetter;
